import type { EntityReconcileCreateResponse } from 'types/api-responses';

// "Deduplicated A + B into S." / "Aliased X and Y." — plain-language bullets
// describing what a reconcile did. Rendered in the post-reconcile banner and
// the Undo Reconcile confirmation modal (mock: reconcile summary list), on both
// the Entity Profile page and the entities list.
//
// One bullet PER DEDUPE GROUP, attributed to that group's own survivor — a
// selection can contain several same-name groups, each with its own survivor.
export function buildReconcileBullets(
  result: EntityReconcileCreateResponse,
  namesById: Record<number, string>
): string[] {
  const nameOf = (id: number) => namesById[id] ?? `Entity ${id}`;
  const bullets: string[] = [];

  (result.dedupeGroups ?? []).forEach((group) => {
    if (group.retired.length === 0) return;
    bullets.push(
      `Deduplicated ${group.retired
        .map((m) => m.name || nameOf(m.id))
        .join(' + ')} into ${group.survivor.name || nameOf(group.survivor.id)}.`
    );
  });
  if (result.aliasPairs.length > 0) {
    const members = Array.from(new Set(result.aliasPairs.flat()));
    bullets.push(`Aliased ${members.map(nameOf).join(' and ')} together.`);
  }
  return bullets;
}
